import * as React from "react"

const MOBILE_BREAKPOINT = 768

/** Shared breakpoint (px) used by list pages to switch from table to card layout. */
export const LIST_PAGE_MOBILE_BREAKPOINT = 900

export function useIsMobile() {
  return useMobileBreakpoint(MOBILE_BREAKPOINT)
}

// Reactive viewport-width predicate. `matchMedia('change')` only fires when the
// boundary is crossed (not on every resize pixel), so this is cheaper than a raw
// `resize` listener for breakpoint-style queries.
export function useMobileBreakpoint(threshold: number): boolean {
  const [isMobile, setIsMobile] = React.useState(() =>
    typeof window === "undefined" ? false : window.innerWidth < threshold,
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${threshold - 1}px)`)
    const onChange = () => setIsMobile(window.innerWidth < threshold)
    mql.addEventListener("change", onChange)
    // reason: initial sync on mount — reads the current viewport width once so the
    // hook returns the correct value before the first matchMedia 'change' event fires.
    // The event callback only fires on crossing the boundary, not on mount, so it
    // cannot cover this. Directive kept inline so it binds to the setState statement
    // (a directive on its own line above a multi-line comment binds to the comment).
    setIsMobile(window.innerWidth < threshold) // eslint-disable-line react-hooks/set-state-in-effect
    return () => mql.removeEventListener("change", onChange)
  }, [threshold])

  return isMobile
}
